import { render, staticRenderFns } from "./ShareholdersList.vue?vue&type=template&id=47cdcfbe&scoped=true"
import script from "./ShareholdersList.vue?vue&type=script&lang=js"
export * from "./ShareholdersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cdcfbe",
  null
  
)

export default component.exports